// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2b40e908","633":"0e92bfd1","829":"b750fe27"}[chunkId] + ".chunk.js";
};